<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions>
        <TableSetting v-model="tableData.title" />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox" ref="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          :height="tableHeight"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <template v-for="(item, index, key) in tableData.title">
            <el-table-column
              :key="key"
              :prop="item.prop"
              :label="item.label"
              :sortable="item.sortable"
              :filters="item.filters"
              :filter-method="item.filterHandler"
              :min-width="item.minW"
              :width="item.w"
              :fixed="item.fixed"
              v-if="item.show"
            >
              <section slot-scope="scope">
                <section
                  v-if="scope.column.property === 'customerCode'"
                  @click="toDetail(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <section
                  v-else-if="scope.column.property === 'lineNumber'"
                  @click="toLine(scope.row)"
                >
                  <span class="primary cur">{{
                    scope.row[scope.column.property]
                  }}</span>
                </section>
                <span v-else-if="scope.column.property === 'remark'">
                  <el-popover
                    v-if="scope.row[scope.column.property].length > 10"
                    :content="scope.row[scope.column.property]"
                    trigger="hover"
                  >
                    <section slot="reference">
                      <span class="primary">{{
                        scope.row[scope.column.property].substr(0, 9) + '...'
                      }}</span>
                    </section>
                  </el-popover>
                  <span v-else>{{ scope.row[scope.column.property] }}</span>
                </span>
                <section v-else>
                  {{ scope.row[scope.column.property] }}
                </section>
              </section>
            </el-table-column>
          </template>
          <!-- 常规列表项 end -->
          <!-- 操作按钮 -->
          <el-table-column
            prop="control"
            label="操作"
            width="200"
            fixed="right"
          >
            <template slot-scope="scope">
              <section>
                <qx-permpisions permpisions="">
                  <span
                    class="primary cur"
                    @click="downloadOriginFile(scope.row)"
                    >下载原文件</span
                  >
                </qx-permpisions>
                <qx-permpisions
                  permpisions=""
                  v-if="
                    scope.row.failNum > 0 &&
                    scope.row.state !== 0 &&
                    scope.row.state !== 1 &&
                    scope.row.state !== 4
                  "
                >
                  <span class="primary cur" @click="downloadReason(scope.row)"
                    >下载失败原因</span
                  >
                </qx-permpisions>
              </section>
            </template>
          </el-table-column>
          <!-- 操按钮 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  importList,
  downloadImportOriginFile,
  downloadImportReason,
  downloadFailFail,
} from 'api/system';
import TableSetting from 'components/tableSetting/tableSetting';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    TableSetting,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          { prop: 'userName', label: '操作人', fixed: true },
          { prop: 'bizName', label: '业务名称' },
          { prop: 'batchId', label: '批次号' },
          { prop: 'stateName', label: '状态' },
          { prop: 'remark', label: '备注', w: 180 },
          { prop: 'createDate', label: '创建时间' },
          { prop: 'updateDate', label: '更新时间' },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: importList,
    async downloadOriginFile (item) {
      this.tableData.loading = true;
      const res = await downloadImportOriginFile({
        flowIds: item.flowId,
        _GRID_TYPE: 'jq',
      });
      this.tableData.loading = false;
      if (!res.failed && res.rows[0]) {
        window.open(res.rows[0].fullPath);
      } else if (!res.failed) {
        const res = await downloadFailFail(item);
        window.open(res.fullPath);
        // this.$message.fail('文件下载失败');
      }
    },
    async downloadReason (item) {
      this.tableData.loading = true;
      const res = await downloadImportReason({
        failedType: 1,
        id: item.id,
      });
      this.tableData.loading = false;
      if (!res.failed) {
        if (res.items && res.items.length) {
          window.open(res.items[0].fullPath);
        } else {
          const res = await downloadFailFail(item);
          window.open(res.fullPathUrl);
        }
      } else {
        this.$message({
          type: 'error',
          message: '文件下载失败',
        });
      }
      // if (!res.failed && res.items[0]) {
      //   window.open(res.items[0].fullPath);
      // } else if (!res.failed) {
      //   this.$message({
      //     type: 'error',
      //     message: '文件下载失败',
      //   });
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
.control {
  span {
    margin-right: 16px;
  }
}
</style>
